import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './components/home/home.component';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//PRIMENG - No borrar
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';

//PRIMENG - programador
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { DataViewModule } from 'primeng/dataview';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SkeletonModule } from 'primeng/skeleton';
import { PasswordModule } from 'primeng/password';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { AccordionModule } from 'primeng/accordion';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabViewModule } from 'primeng/tabview';
import { FileUploadModule } from 'primeng/fileupload';

//COMPONENTS
import { HomeMenuButtonsComponent } from '../base/components/home-menu-buttons/home-menu-buttons.component';
import { CursosGridComponent } from './components/cursos-grid/cursos-grid.component';
import { FormPostulacionComponent } from './components/form-postulacion/form-postulacion.component';
import { CursosOfertadosComponent } from './components/cursos-ofertados/cursos-ofertados.component';
import { CursoDetalleComponent } from './components/curso-detalle/curso-detalle.component';
import { FormLoginComponent } from './components/form-login/form-login.component';
import { MicuentaComponent } from './components/micuenta/micuenta.component';
import { DashboardComponent } from './components/micuenta/dashboard/dashboard.component';
import { SidebarComponent } from './components/micuenta/sidebar/sidebar.component';
import { PostulacionesComponent } from './components/micuenta/postulaciones/postulaciones.component';
import { CursosComponent } from './components/micuenta/cursos/cursos.component';
import { CertificadosComponent } from './components/micuenta/certificados/certificados.component';
import { ConsejosComponent } from './components/micuenta/consejos/consejos.component';
import { CursosCarouselComponent } from './components/cursos-carousel/cursos-carousel.component';
import { BannerCarouselComponent } from './components/banner-carousel/banner-carousel.component';
import { PreguntasFrecuentesComponent } from './components/preguntas-frecuentes/preguntas-frecuentes.component';
import { ModalPostulacionComponent } from './components/modal-postulacion/modal-postulacion.component';
import { PanelModule } from 'primeng/panel';
import { RecuperarCodigoComponent } from './components/recuperar-codigo/recuperar-codigo.component';
import { DatosPersonalesComponent } from './components/micuenta/datos-personales/datos-personales.component';

@NgModule({
    declarations: [
        HomeComponent, 
        HomeMenuButtonsComponent, 
        CursosGridComponent, 
        FormPostulacionComponent, 
        CursosOfertadosComponent, 
        CursoDetalleComponent, 
        FormLoginComponent, 
        MicuentaComponent, 
        DashboardComponent, 
        SidebarComponent, 
        PostulacionesComponent, 
        CursosComponent, 
        CertificadosComponent, 
        ConsejosComponent, 
        CursosCarouselComponent, 
        BannerCarouselComponent, 
        PreguntasFrecuentesComponent, 
        ModalPostulacionComponent, 
        RecuperarCodigoComponent, DatosPersonalesComponent
    ],
    imports: [
        FormsModule,
        TranslateModule,
        CommonModule,
        BrowserAnimationsModule,
        //PRIMENG
        ButtonModule,
        InputTextModule,
        TableModule,
        OverlayPanelModule,
        MenuModule,
        TooltipModule,
        ReactiveFormsModule,
        CardModule,
        DropdownModule,
        CalendarModule,
        CarouselModule,
        DataViewModule,
        ToastModule,
        SkeletonModule,
        PasswordModule,
        InputSwitchModule,
        MessageModule,
        MessagesModule,
        AccordionModule,
        DialogModule,
        PanelModule,
        ProgressSpinnerModule,
        TabViewModule,
        FileUploadModule,
    ]
})
export class ProjectModule {}
